import Vue from 'vue';

/**
 * Transforme un nombre dans le format suivant : XXX XXX,XX
 * @param valeur Nombre à transformer.
 * @param nombreDecimales Nombre de decimales à conserver / compléter si besoin.
 * @returns Le nombre au format XXX XXX,XX ou une chaîne vide.
 */
Vue.filter('number', function (valeur: number, nombreDecimales: number = 3, valeurParDefaut: string = ''): string {
    // N'affiche que les nombres définis.
    if (valeur == null || nombreDecimales < 0) {
        return valeurParDefaut;
    }

    // Transformation des entiers (insère un espace devant chaque groupe de trois chiffres).
    // On est obligé d'inverser la chaine au préalable pour avoir les espaces au bon endroit.
    let entiers = String(Math.trunc(Math.abs(valeur))).split('').reverse().join('');
    const entiersRegex = entiers.match(/.{1,3}/g);
    if (entiersRegex != null) {
        entiers = entiersRegex.map((e) => e.split('').reverse().join(''))
            .reverse().join(' ');
    }

    // Les signes doivent être collés aux chiffres.
    if (valeur < 0) {
        entiers = '-' + entiers;
    }

    // Transformation des décimaux (force la longueur à nombreDecimales).
    const valeurDecimale = ',' + String(Math.abs(Math.round(valeur * Math.pow(10, nombreDecimales))) / Math.pow(10, nombreDecimales));
    let decimaux = '';

    // N'affiche pas la virgule si on veut un entier.
    if (nombreDecimales > 0) {
        // Récupère la partie décimale.
        if (valeurDecimale.includes('.')) {
            decimaux = valeurDecimale.split('.')[1];
        } else {
            /* Si on obtient un entier différent de la partie entière de la valeur d'entrée, c'est
                qu'on a arrondi à l'entier supérieur, mais si la valeur initiale est négative, il faut 
                diminuer la valeur absolue de 1. */ 
            const valeurDecimaleEntiere = valeurDecimale.substring(1);
            const entiersSansEspace = entiers.replace(' ', '')
            if (valeurDecimaleEntiere !== entiersSansEspace && valeur > 0) {
                entiers = (parseInt(entiersSansEspace.replace(' ', '')) + 1).toString();
            } else if ('-' + valeurDecimaleEntiere !== entiersSansEspace && valeur < 0) {
                entiers = (parseInt(entiersSansEspace.replace(' ', '')) - 1).toString();
            }
        }

        // Complète le nombre de décimales requises avec des zéros.
        decimaux = ',' + decimaux + new Array(nombreDecimales - decimaux.length + 1).join('0');
    }

    // Assemblage des deux composantes.

    return entiers + decimaux;
});
